export const groupBy = (array, property) => {
    return array.reduce((grouped, element) => ({
        ...grouped,
        [element[property]]: [...(grouped[element[property]] || []), element]
    }), {})
}